export default __webpack_public_path__ + "static/media/icon_appointments.41523e89.svg";